const LocalStorageKey = {
	Language: "language",
};

export default LocalStorageKey;
